//import PriceRangeSlider from "./PriceRangeSlider";
import "../styles/filters.css";
export default function Filters({
  search,
  setSearch,
  category,
  setCategory,
  sort,
  setSort,
  brands,
  toggleBrand,
  uniqueBrands,
  onlyAvailable,
  setOnlyAvailable,
  onlyDiscounted,
  setOnlyDiscounted,
  onlyGiftProducts,
  setOnlyGiftProducts,

  minPrice,
  setMinPrice,
  currentMaxPrice,
  setCurrentMaxPrice,
  maxProductPrice,
  applyPriceFilter,
}) {
  return (
    <div className="filters">
      

      <label className="switch">
        <span className="switch-text"> محصولات موجود</span>

        <input
          type="checkbox"
          checked={onlyAvailable}
          onChange={(e) => setOnlyAvailable(e.target.checked)}
        />

        <span className="slider"></span>
      </label>

      <label className="switch">
        <span className="switch-text"> محصولات با تخفیف</span>

        <input
          type="checkbox"
          checked={onlyDiscounted}
          onChange={(e) => setOnlyDiscounted(e.target.checked)}
        />

        <span className="slider"></span>
      </label>

      <label className="switch">
        <span className="switch-text">محصولات با هدیه</span>

        <input
          type="checkbox"
          checked={onlyGiftProducts}
          onChange={(e) => setOnlyGiftProducts(e.target.checked)}
        />

        <span className="slider"></span>
      </label>

      
    </div>
  );
}
